import _ from 'lodash'

export const activeGroupIdSelector = (state) => state.getIn(['ui', 'groupStack', 'activeGroup'])
export const groupMembersSelector = (state, groupId) =>
    state
        .getIn(['ui', 'entityStack', 'groups', 'groups'])
        .find((group) => _.toString(group.get('id')) === _.toString(groupId))
export const activeGroupSelector = (state) => {
    const activeGroupId = state.getIn(['ui', 'groupStack', 'activeGroup'])

    return state
        .getIn(['ui', 'entityStack', 'groups', 'groups'])
        .find((groupEntity) => _.toString(groupEntity.get('id')) === _.toString(activeGroupId))
}

export const sessionIdSelector = (state) => state.getIn(['authorization', 'sessionId'])
export const groupMonitoringParamsSelector = (state) =>
    state.getIn(['ui', 'groupMonitoring', 'groupMonitoringData', 'params'])
export const userEmailSelector = (state) => state.getIn(['authorization', 'user', 'email'])

export const getMonitoringDefaults = (state) => ({
    frequency: 'd23',
    notifications: 'true',
    mailTo: [state.getIn(['authorization', 'user', 'email'])],
    sendInFormat: 'INLINE_HTML',
    params: state.getIn(['ui', 'groupMonitoring', 'groupMonitoringData', 'params']),
})
